export default __webpack_public_path__ + "static/media/question_mark.e3072365.png";